<!-- 
	AdminHeader
	props: User
  role: Admin
	Called by @/App to display to user with 'isStrideAdmin === true' in Firestore
-->

<template>
	<div 
		v-if="user.additionalData !== null && user.additionalData.isStrideAdmin === true" 
		class="admin-header bg-red-400 w-full px-8 py-2 text-white"
	>
		<div class="flex items-center w-full">
			<router-link to="/" class="hidden sm:block link">
				<span>You are Logged in as Admin</span>
			</router-link>
			<div class="flex-1 text-center sm:text-right">
				<router-link to="/admin-news" class="link">
					<span>Manage News</span>
				</router-link>
				<router-link to="/admin" class="link">
					<span>User Management</span>
				</router-link>
			</div>
		</div>
	</div>
</template>

<script>
	import { mapGetters } from "vuex";

	export default {
		name: "AdminHeader",
		computed: {
			...mapGetters({
				user: "user",
			}),
		},
	};
</script>

<style lang="scss" scoped>
	.admin-header .link {
		cursor: pointer;
		
		&:not(:first-child) {
			margin-left: 22px;
		}
		
		:hover {
			box-shadow: none !important;
			color: #6f6f6f !important;
		}
	}
</style>
